import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import AddShopPageSliderComponent from '../components/AddShopPageSliderComponent';
import HeaderComponent from '../components/HeaderComponent';

class AddShopPageSliderPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <AddShopPageSliderComponent />
            </div>
        );
    }
}

export default AddShopPageSliderPage;